import { Component } from 'react'
import { observer } from 'mobx-react'

import * as h from 'h'

import StandardContent from 'components/Popout/StandardContent'
import RelatedElements from 'components/Popout/RelatedElements'

import styles from './styles.scss'

@observer(['UiStore'])
export default class ResourceView extends Component {
  render () {
    const { element } = this.props
    const { name, image, children, descShort, url } = element

    const visitSite = h.maybe(url,
      h.a({ href: url, target: '_blank', ...h.ca(styles.visitSite) }, 'Visit Site'))

    return h.div(h.ca(styles.resourceView),
      h.h(StandardContent, {
        title: name,
        preContent: visitSite,
        content: descShort,
        image: image.details,
        vanillaImage: false
      }),
      h.div(h.ca(styles.relatedElements),
        h.h(RelatedElements, {
          title: 'Related Resources',
          elements: children,
          small: true
        })
      )
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/ResourceView/index.js